import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// import modules of stores
import * as user from './user';
import * as signup from './signup';
import * as notification from './notification/';
import * as sweetalert2 from './notification/sweetalert2';
import * as layout from './layout/';
import * as pagseguro from './pagseguro/';
import * as router from './router/';
import * as payment from './payment/';
import * as supplierNetwork from './supplier-network/';
import * as checkout from './checkout/';

import supplier from './supplier';

export default new Vuex.Store({
    modules: {
        user: {
            namespaced: true,
            ...user
        },
        signup: {
            namespaced: true,
            ...signup
        },
        notification: {
            namespaced: true,
            ...notification
        },
        sweetalert2: {
            namespaced: true,
            ...sweetalert2
        },
        layout: {
            namespaced: true,
            ...layout
        },
        pagseguro: {
            namespaced: true,
            ...pagseguro
        },
        router: {
            namespaced: true,
            ...router
        },
        payment: {
            namespaced: true,
            ...payment
        },
        supplierNetwork: {
            namespaced: true,
            ...supplierNetwork
        },
        checkout: {
            namespaced: true,
            ...checkout
        },
        supplier
    }
});
